import queryString from "query-string";

import AxiosInstance from "@/config/AxiosInstance";
import { API_BASE_URL, API_BASE_URL_ADMIN } from "@/config/appConfig";

type NationalPlusUpServicePayload = Record<string, any>;

type NationalPlusUpCampaignQuery = NationalPlusUpServicePayload & {
  id?: string | number;
  status?: string | number;
  row?: string | number;
  page?: string | number;
  is_deleted?: string | number;
  brand_id?: string | number;
  fk_participant_id?: string | number;
};

type NationalPlusUpDraftLookupParams = {
  campaignId?: string | number;
  fkParticipantId?: string | number;
};

export const nationalPlusUpCampaignService = {
  getNationalPlusUpCampaign,
  draftNationalPlusUpCampaign,
  getDraftNationalPlusUpCampaign,
  confirmNationalPlusUpCampaignJoin,
};

function getNationalPlusUpCampaign(data: NationalPlusUpCampaignQuery) {
  const query = queryString.stringify({
    id: "",
    status: 1,
    row: 50,
    page: 1,
    is_deleted: 0,
    ...data,
  });

  // Temporary compatibility: campaign detail still mirrors existing RRD data.
  return AxiosInstance.get(`${API_BASE_URL_ADMIN}/postcardCampaign?${query}`);
}

function draftNationalPlusUpCampaign(data: NationalPlusUpServicePayload) {
  return AxiosInstance.post(
    `${API_BASE_URL}/postcard/rrd/orders/draft/bulk`,
    data
  );
}

function getDraftNationalPlusUpCampaign({
  campaignId,
  fkParticipantId,
}: NationalPlusUpDraftLookupParams) {
  return AxiosInstance.post(
    `${API_BASE_URL}/postcard/rrd/campaigns/draftsCampaignLocation`,
    {
      campaignId,
      fkParticipantId,
    }
  );
}

function confirmNationalPlusUpCampaignJoin(data: NationalPlusUpServicePayload) {
  return AxiosInstance.post(
    `${API_BASE_URL}/postcard/rrd/orders/draft/confirm/bulk`,
    data
  );
}
